import { WhatsAppTemplateParamModel } from './whatsapp-template-param.model';

export interface MultiTemplateWhatsappTemplateModel {
  whatsAppTemplateName: string;
  whatsAppTemplateParams: WhatsAppTemplateParamModel[];
}
